export default {
  required: '入力してください',
  requiredSelect: '選択してください',
  basicInfo: '基本情報',
  serviceProvider: 'プロバイダー',
  serviceProviderPlaceholder: 'プロバイダーを選択してください',
  apiKey: 'API Key',
  apiKeyPlaceholder: 'API Keyを入力してください',
  apiSecret: 'API Secret',
  apiSecretPlaceholder: 'API Secretを入力してください',
  smsSignature: 'SMS署名',
  smsSignaturePlaceholder: 'SMS署名を入力してください',
  channelConfig: '海外チャネル設定',
  addChannel: 'チャネル追加',
  countryRegion: '国/地域',
  operator: 'プロバイダー',
  operatorPlaceholder: '選択してください',
  templateCode: 'テンプレートコード',
  templateCodePlaceholder: 'テンプレートコードを入力してください',
  status: 'ステータス',
  actions: '操作',
  edit: '編集',
  delete: '削除',
  sendTest: 'SMS送信テスト',
  testPhone: '電話番号を入力してください',
  sendTestSms: 'テストSMS送信',
  sendTestSuccess: 'テストSMS送信成功',
  sendTestFail: 'テストSMS送信失敗',
  save: '設定を保存',
  saveSuccess: '保存しました',
  deleteConfirm: 'このチャネルを削除してもよろしいですか？',
  deleteSuccess: '削除しました',
  selectChannel: 'チャネルを選択してください',
  // タブ
  tabConfig: 'SMS設定',
  tabSendLog: '送信ログ',
  // ログフィルター
  logMobile: '電話番号',
  logMobilePlaceholder: '電話番号を入力してください',
  logTemplateCode: 'テンプレートコード',
  logTemplateCodePlaceholder: 'テンプレートコードを入力してください',
  logStatus: '送信ステータス',
  logStatusAll: '全ステータス',
  logStatusSuccess: '成功',
  logStatusFailed: '失敗',
  logProvider: 'プロバイダー',
  logProviderAll: '全プロバイダー',
  logSendTime: '送信時間',
  logStartDate: '開始日',
  logEndDate: '終了日',
  logSearch: '検索',
  logReset: 'リセット',
  logCollapse: '折りたたむ',
  logExpand: '展開',
  logAllCountries: '全国家/地域',
  // ログテーブル
  logColumnCountry: '国/地域',
  logColumnMobile: '電話番号',
  logColumnTemplateCode: 'テンプレートコード',
  logColumnProvider: 'プロバイダー',
  logColumnStatus: 'ステータス',
  logColumnSendTime: '送信時間',
  logColumnMessageId: 'プロバイダーメッセージID',
  logColumnActions: '操作',
  logDetail: '詳細',
  // 統計カード
  statTotalCount: '送信総数',
  statSuccessCount: '成功数',
  statFailedCount: '失敗数',
  statSuccessRate: '成功率',
  // 詳細ドロワー
  detailTitle: 'SMS送信詳細',
  detailMobile: '電話番号',
  detailCountry: '国/地域',
  detailProvider: 'プロバイダー',
  detailTemplateCode: 'テンプレートコード',
  detailTemplateName: 'テンプレート名',
  detailContent: 'SMS内容',
  detailStatus: '送信ステータス',
  detailMessageId: 'プロバイダーメッセージID',
  detailRequestId: 'プラットフォームリクエストID',
  detailSendTime: '送信時間',
  detailCallbackTime: 'コールバック時間',
  detailResponse: 'レスポンス',
  detailErrorCode: 'エラーコード',
  detailErrorMsg: 'エラーメッセージ',
  detailClose: '閉じる',
  detailNone: '-',
};
